import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';

interface InvoiceItemProps {
  title: string;
  subtitle: string;
  price: number;
  quantity: number;
}

function InvoiceItem({ title, subtitle, price, quantity }: InvoiceItemProps) {
  return (
    <div className="w-full flex flex-col ">
      <span className="font-arial font-semibold text-text-black">{title}</span>
      <span className="text-sm text-text-gray font-arial">{subtitle}</span>
      <div className="flex">
        <span className="text-purple-300 font font-arial font-semibold">
          ${formatCurrency(price)}
        </span>
        <span className="font-arial font-semibold text-text-gray ml-1">
          x {quantity}
        </span>
      </div>
      <hr className="my-2" />
    </div>
  );
}

export default InvoiceItem;
